"use client";
import MainLayout from "@/components/layout/mainLayout";
import { useEffect, useState } from "react";
import BuyNowCart from "@/components/common/BuyNowCart";
import NewCollectionBanner from "@/components/newoctavecollection/NewCollectionBanner";
import { getCheckoutLineItems } from "@/util/utils";
import ScoMeta from "@/components/scometa";
import ThanksCaskModal from "@/components/newoctavecollection/ThanksCaskModal";
import OwnACask from "@/components/newoctavecollection/OwnACask";
import { useAppCommonStore } from "@/zustand/appCommon";

const CreateYourOwn = (props: any) => {
  const { data, meta } = props;

  const [octavecollectionData, setOctavecollectionData]: any = useState(null);
  const [openOwnCaskModal, setOpenOwnCaskModal]: any = useState(false);
  const [openCaskThanksModal, setOpenCaskThanksModal]: any = useState(false);

  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  useEffect(() => {
    if (data) {
      setOctavecollectionData(data?.data?.attributes?.blocks);
    }
  }, [data]);
  const renderOctaveCollectionPage = () => {
    return (
      <>
        {octavecollectionData && octavecollectionData.length
          ? octavecollectionData.map((content: any, index: any) => {
              switch (content.__component) {
                case "sections.banner":
                  return (
                    <div key={index}>
                      <NewCollectionBanner data={content} />
                    </div>
                  );

                // case "octave.about-the-collection":
                //   return <OctaveDetailsSection key={content?.id + index} data={content} />;

                default:
                  return null;
              }
            })
          : null}
      </>
    );
  };

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  const toggleOwnCaskModal = () => {
    setOpenOwnCaskModal(!openOwnCaskModal);
  };
  return (
    <>
      {/* <OwnACaskModal openOwnCaskModal={openOwnCaskModal} toggleOwnCaskModal={toggleOwnCaskModal} setOpenCaskThanksModal={setOpenCaskThanksModal} /> */}
      <ThanksCaskModal
        openModal={openCaskThanksModal}
        setOpenModal={setOpenCaskThanksModal}
      />
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <head>
        <ScoMeta meta={meta ? meta : {}} />
      </head>
      <MainLayout checkout={checkout} toggleCartSidebar={toggleCartSidebar}>
        <div className="new-octave-collection">
          {octavecollectionData && renderOctaveCollectionPage()}
          <OwnACask
            data={data}
            openOwnCaskModal={openOwnCaskModal}
            setOpenCaskThanksModal={setOpenCaskThanksModal}
            pagename=""
          />
        </div>
      </MainLayout>
    </>
  );
};

export default CreateYourOwn;
